export const JET_MIN_SPEED_ANIM = "jetMinSpeed";
export const JET_MAX_SPEED_ANIM = "jetMaxSpeed";
export const EXPLOSION_ANIM = "explosion";
